export const QUOTE_SETTINGS = {
  DEFAULT_EXPIRATION_DAYS: 'default-expiration-days',
  ALLOW_PAY_BEFORE_ESIGN: 'allow-pay-before-esign',
  DEFAULT_TOTAL_PREFERENCE: 'default-total-preference',
  DISPLAY_TCV_ON_QUOTE: 'display-tcv-on-quote',
  QUOTE_TOTAL_DISPLAY_PREFERENCE: 'quote-total-display-preference'
};
export const QUOTE_TOTAL_DISPLAY_PREFERENCE_KEYS = {
  HS_TCV: 'hs_tcv',
  HS_QUOTE_AMOUNT: 'hs_quote_amount'
};